define({
    // Array of country codes to display as separate buttons 
    BUTTON_COUNTRY_CODES: ['CH'],
    
    // Array of country codes to display first in the list of countries, within the order defined here
    FAVOURITE_COUNTRY_CODES: ['DE', 'FR', 'AT', 'IT', 'LI'],
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/constants/MFPFavouriteCountryCodesForNationality.js